import React, { useEffect, useState } from 'react';
import { addAccount, updateAccount } from 'app/api-ws/accounts-ws';
import {
  Alert,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { Span } from 'app/components/Typography';
import TermsAndConditionsDialog from '../components/TermsAndConditionsDialog';
import { getServiceById } from 'app/api-ws/service-ws';
import moment from 'moment';
import useAuth from 'app/hooks/useAuth';

function AccountsForm({ account, patientId, handleCloseDialog, handleCloseDialogSubmit }) {
  console.log('account', account);
  const disabledbutton = account?.balance === 0 ? true : false;
  const { user } = useAuth();
  let date = new Date().toISOString().split('T')[0];
  if (account && account.accountsDate) {
    date = account.accountsDate.split('T')[0];
  }
  const accountDate = date;
  const [refTreatmentPlan, setRefTreatmentPlan] = useState(account?.refTreatmentPlan);
  const [price, setPrice] = useState(account?.price);
  const [paymentMode, setPaymentMode] = useState(account?.paymentMode || 'Cash');
  const [balance, setBalance] = useState(account?.balance);
  const [paymentReceived, setPaymentReceived] = useState(account?.paymentReceived || 0);
  const [paymentStatus, setPaymentStatus] = useState(account?.paymentStatus || 'Pending');
  const [discount, setDiscount] = useState(account?.discount);
  const [orgPrice, setOrgPrice] = useState();

  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');
  const [acceptTerms, setAcceptTerms] = useState(account ? true : false);
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);

  function showSnackBar() {
    setOpen(true);
  }

  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }
  const handleAcceptTermsChange = () => {
    setAcceptTerms(!acceptTerms);
  };

  const handleOpenTermsDialog = () => {
    setTermsDialogOpen(true);
  };

  const handleCloseTermsDialog = () => {
    setTermsDialogOpen(false);
  };

  const fetchServicesById = (refTreatmentPlan) => {
    getServiceById(user._id, user?.authToken)
      .then((res) => {
        console.log('res', res.data.data);
        const service = res.data.data.find((service) => service.serviceName === refTreatmentPlan);
        if (service) {
          const servicePrice = service.servicePrice;
          setOrgPrice(servicePrice);
        } else {
          console.log('Service not found');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const discountFunction = () => {
    setDiscount((prev) => !prev);
    if (account?.discount) {
      fetchServicesById(refTreatmentPlan);
      const pricee = account?.price;
      if (discount) {
        setPrice(pricee);
      } else {
        setPrice(orgPrice);
      }
    } else {
      if (!discount) {
        const discountedPrice = price - price * 0.1;
        setPrice(discountedPrice);
      } else {
        setPrice(account?.price);
      }
    }
  };

  useEffect(() => {
    if (price === null || paymentReceived === null) {
      setBalance(0);
    } else {
      const calculatedBalance = (price - paymentReceived).toFixed(2);
      setBalance(calculatedBalance);
    }
  }, [price, paymentReceived]);

  const handleSubmit = (event) => {
    const accountRequest = {
      refPatientId: patientId._id,
      accountDate: accountDate,
      refTreatmentPlan: refTreatmentPlan,
      paymentReceived: paymentReceived,
      price: price,
      paymentMode: paymentMode,
      balance: balance,
      discount: discount,
      paymentStatus: paymentStatus
    };

    addAccount(accountRequest, user?.authToken)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 'success') {
          handleCloseDialog();
        } else {
          setSnackBarMessage('Error in adding Account');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in adding Investigation');
        setSnackBarType('error');
        showSnackBar();
      });
    // console.log('submitted');
  };

  const updateAccountSubmit = (event) => {
    const updateAccountRequest = {
      _id: account._id,
      accountDate: accountDate,
      price: price,
      paymentMode: paymentMode,
      paymentReceived: paymentReceived,
      balance: balance,
      discount: discount,
      paymentStatus: paymentStatus
    };

    updateAccount(updateAccountRequest, user?.authToken)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 'success') {
          setSnackBarMessage('Accounts updated Successfully');
          setSnackBarType('success');
          showSnackBar();
          handleCloseDialogSubmit();
        } else {
          setSnackBarMessage('Error in updating Accounts');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((err) => {
        console.log(err);
        setSnackBarMessage('Error in updating Accounts');
        setSnackBarType('error');
        showSnackBar();
      });
    console.log('submitted');
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <Grid sx={{ paddingLeft: '2vh', paddingTop: '10px' }}>
        <ValidatorForm onSubmit={account ? updateAccountSubmit : handleSubmit} onError={() => null}>
          <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} rowSpacing={2}>
            <Grid item xs={12} container alignItems="center" justifyContent="flex-end">
              <Typography variant="subtitle2">
                {moment(account?.accountDate).format('DD MMMM YYYY')}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="refTreatmentPlan"
                label="Treatment Plan"
                variant="outlined"
                fullWidth
                value={refTreatmentPlan}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Treatment Price in ₹ "
                variant="outlined"
                fullWidth
                value={price}
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body1">Discount</Typography>
              <FormControlLabel
                control={
                  <Switch
                    id="standard-basic"
                    color="primary"
                    checked={discount}
                    disabled={disabledbutton}
                    onChange={discountFunction}
                  />
                }
                label={discount ? '10% Discount Applied' : 'No'}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="paymentMode">Payment Mode</InputLabel>
                <Select
                  value={paymentMode}
                  onChange={(e) => {
                    setPaymentMode(e.target.value);
                  }}
                  label="Payment Mode"
                  disabled={disabledbutton}
                  input={<OutlinedInput label="Payment Mode" name="paymentMode" id="paymentMode" />}
                >
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="UPI">UPI</MenuItem>
                  <MenuItem value="Card">Card</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="number"
                id="standard-basic"
                label="Payment  Received in  ₹ "
                variant="outlined"
                fullWidth
                disabled={disabledbutton}
                value={paymentReceived}
                onChange={(event) => setPaymentReceived(event.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="paymentStatus">Payment Status</InputLabel>
                <Select
                  value={paymentStatus}
                  onChange={(e) => {
                    setPaymentStatus(e.target.value);
                  }}
                  label="Payment Status"
                  disabled={disabledbutton}
                  input={
                    <OutlinedInput label="Payment Status" name="paymentStatus" id="paymentStatus" />
                  }
                >
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Completed">Completed</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputLabel htmlFor="balance">Balance in ₹ </InputLabel>
              <TextField
                type="number"
                id="standard-basic"
                variant="outlined"
                fullWidth
                value={balance}
                onChange={(event) => setBalance(event.target.value)}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: '10px', alignItems: 'center' }}>
            {!account && (
              <Grid
                item
                xs={12}
                sm={6}
                style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
              >
                <Checkbox
                  checked={acceptTerms}
                  onChange={handleAcceptTermsChange}
                  name="acceptTerms"
                  color="primary"
                />
                <Typography
                  style={{ color: '#66b5a3', cursor: 'pointer' }}
                  component="span"
                  onClick={handleOpenTermsDialog}
                >
                  Terms and Conditions
                </Typography>

                <TermsAndConditionsDialog open={termsDialogOpen} onClose={handleCloseTermsDialog} />
              </Grid>
            )}
            {account && <Grid item xs={12} sm={6}></Grid>}

            <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={handleCloseDialog} color="primary">
                <Typography color="#66b5a3">Cancel</Typography>
              </Button>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={!acceptTerms}
                style={{
                  backgroundColor: acceptTerms ? '#66b5a3' : '#CCCCCC',
                  color: acceptTerms ? 'white' : '#8C8C8C'
                }}
              >
                <Span sx={{ pl: 1, textTransform: 'capitalize' }}>
                  {account ? 'Save Changes' : 'Add Account'}
                </Span>
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </Grid>
    </>
  );
}

export default AccountsForm;
